import { Toaster } from "@/components/ui/sonner";
import { reactQueryClient } from "@/config/services";
import { useDocumentTitle } from "@/hooks";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

const RootComponent = () => {
  useDocumentTitle(
    import.meta.env.MODE === "production"
      ? "GKP Keuangan"
      : "UAT - GKP Keuangan",
    true
  );

  return (
    <>
      <QueryClientProvider client={reactQueryClient}>
        <Outlet />
        <TanStackRouterDevtools />
        <ReactQueryDevtools initialIsOpen={false} />
        <Toaster />
      </QueryClientProvider>
    </>
  );
};

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  component: RootComponent,
});
